<template>
    <div id="sales-summary" v-if="summary">
        <div v-if="summary.ref_general" class="row">
            {{ $t('production.summary.ref_general_date') }}: <span class="value">{{ formatDate(summary.ref_general)
                }}</span>
        </div>
        <div v-if="summary.ref_delivery" class="row">
            {{ $t('production.summary.ref_delivery_date') }}: <span class="value">{{
                formatDate(summary.ref_delivery)
                }}</span>
        </div>
        <div v-if="summary.forecast_total != null" class="row">
            {{ $t('production.summary.forecast') }}: <span class="value">{{ formatCurrency(summary.forecast_total) }}</span>
        </div>
        <div v-if="summary.agg_actual != null" class="row">
            {{ $t('production.summary.current') }}: <span class="value">{{ formatCurrency(summary.agg_actual) }}</span>
        </div>
        <div v-if="summary.agg_difference_percentage != null" class="row current">
            {{ $t('sales.table.header.difference') }}: <span class="value"
                :class="{ positive: summary.agg_difference_percentage > 0, negative: summary.agg_difference_percentage < 0, neutral: summary.agg_difference_percentage == 0 }">{{
                    formatDisplayPercent(summary.agg_difference_percentage, 1, true) }}</span>
        </div>
        <div v-if="summary.last_update" class="row">
            {{ $t('production.summary.last_update') }}: <span class="value update">{{ formatDateTime(summary.last_update) }}</span>
        </div>

    </div>
</template>

<script>
import { formatPercent } from '@/utils/numberFormat'
import { formatDisplayDateFromStore } from '@/utils/dateFormatters'
import { formatDate as formatReferenceDate } from '@/utils/dateUtils'
import { formatCurrency } from "@/utils/formatters";
export default {
    name: 'Sidebar',
    props: {
        summary: { type: Object },
    },
    methods: {
        formatDisplayPercent(value, level = 1, allowNegative = false) { return formatPercent(value, this.$i18n.locale, level, { allowNegative }) },
        formatDate(date) {
            return formatReferenceDate(date)
        },
        isValidDate(dateString) {
            return moment(dateString, 'YYYY-MM-DD', true).isValid()
        },
        formatDateTime(date) {
            return formatDisplayDateFromStore(date, { includeTime: true })
        },
        formatCurrency(amount) {
            return formatCurrency(amount)
        }
    },
    created() { },
    watch: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    #sales-summary {
        width: 100%;
        bottom: 0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .row {
            display: flex;
            flex-direction: row;
            align-content: center;
            align-items: center;
            justify-content: space-between;
            gap: 25px;
            flex-wrap: nowrap;
            word-break: break-word;
            width: 100%;
            padding: 4px 0;
            @include font-size(xs);
            line-height: 100%;

            .value {
                font-family: $text-bold;
                width: 35%;
                text-align: right;
                @include font-size(xs);

                &.update {
                    font-family: $text;
                }
            }

            &.level {
                margin-top: 8px;

                .value {
                    padding: 4px 8px;
                    border-radius: 3px;
                    background-color: $color-warning-500;
                }
            }

            &.current {
                margin-top: 0px;

                .value {
                    padding: 4px 8px;
                    border-radius: 3px;
                    color: #fff;
                    width: auto;
                    min-width: 90px;
                    text-align: center;

                    &.positive {
                        background-color: $color-success-500;
                    }

                    &.negative {
                        background-color: $color-error-500;
                    }

                    &.neutral {
                        background-color: $color-neutral-500;
                    }
                }
            }
        }
    }
</style>